export default "__VITE_ASSET__CUFKm8IH__"